import { ApolloQueryResult } from 'apollo-client/core/types';

import {
    freelancerPublicQuery,
    freelancersListQuery
} from '../graphql/queries/public-grid/freelancers';
import { mapLangToGdLanguageInput } from '../mappers/freelancers';
import { LangUtils } from '../service/Lang/Lang';
import {
    FreelancerPublicQuery,
    FreelancersListQuery
} from '../typings/graphql-public-grid';

import { BaseDataProvider } from './BaseDataProvider/BaseDataProvider';

const LANG = mapLangToGdLanguageInput(LangUtils.getCurrentLang());

export class IncognitoDataProvider extends BaseDataProvider {
    public fetchFreelancersListData() {
        return this.createQuery<FreelancersListQuery>(freelancersListQuery, {
            variables: {
                lang: LANG
            }
        }).then(
            (result: ApolloQueryResult<FreelancersListQuery>) => result.data
        );
    }

    public fetchFreelancerPublicData(freelancerLogin: string) {
        return this.createQuery<FreelancerPublicQuery>(freelancerPublicQuery, {
            variables: {
                freelancerLogin,
                lang: LANG
            }
        }).then(response => response.data);
    }
}
